import { render } from "./ItemImageTapeComponent.vue?vue&type=template&id=4ad2cf28"
import script from "./ItemImageTapeComponent.vue?vue&type=script&lang=js"
export * from "./ItemImageTapeComponent.vue?vue&type=script&lang=js"

import "./ItemImageTapeComponent.vue?vue&type=style&index=0&id=4ad2cf28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__